<nb-card style="min-width: 50vw; max-height: 75vh" [status]="entryStatus">
  <nb-card-header>
    Confirm Hardware
    {{ displayMessage ? " - " + displayMessage : "" }}</nb-card-header
  >
  <nb-card-body style="overflow-y: scroll">
    <!-- <div style="max-width: 450px"> -->
    <div
      style="
        display: flex;
        gap: 5px;
        flex-direction: column;
        align-items: center;
      "
    >
      <p>
        Please check through the below asset tags and press submit to confirm
        dispatch. It is not possible to undo this action without contacting
        support.
      </p>

      <!-- <div *ngIf="displayMessage.length > 0">
        <strong>{{ displayMessage }}</strong>
      </div> -->
      <div
        style="display: flex; flex-direction: column; flex-grow: 1; gap: 15px"
      >
        <div>       
          <label>Enter a dispatch reference(*):</label>
          <input
            type="text"
            nbInput
            fullWidth
            [(ngModel)]="dispatchReference"
          />
        </div>
        <ag-grid-angular
          #agGrid
          style="width: 100%"
          class="ag-theme-alpine ag-theme-alpine-compact"
          [rowData]="hardwareTable.rowData"
          [columnDefs]="hardwareTable.columnDefs"
          [context]="hardwareTable.context"
          [components]="hardwareTable.frameworkComponents"
          [defaultColDef]="hardwareTable.defaultColDef"
          [gridOptions]="hardwareTable.gridOptions"
          [enableCellTextSelection]="true"
          [rowSelection]="hardwareTable.rowSelection"
          [rowClassRules]="hardwareTable.rowClassRules"
          (gridReady)="onGridReady($event)"
          (firstDataRendered)="hardwareTable.headerHeightSetter()"
          (columnResized)="hardwareTable.headerHeightSetter()"
          [pagination]="true"
          [paginationPageSize]="hardwareTable.paginationPageSize"
          [paginationNumberFormatter]="hardwareTable.paginationNumberFormatter"
          [domLayout]="hardwareTable.domLayout"
        >
        </ag-grid-angular>
        <hr />
        <div *ngIf="selectedDrives.length > 0 || selectedScanners.length > 0">
          <strong>
            Selected Drives: {{ selectedDrives.length }} | Selected Scanners:
            {{ selectedScanners.length }}
          </strong>
        </div>
        <button
          class="align-quality"
          type="button"
          nbButton
          fullWidth
          status="warning"
          (click)="dispatchHardware()"
          [disabled]="
            hardwareTable.rowData.length === 0 || displayMessage.length > 0
          "
        >
          Submit List
        </button>
      </div>
    </div>
    <!-- </div> -->
  </nb-card-body>
</nb-card>
